import { RouteComponentProps } from "@reach/router";
import { Row, Col, Typography, Space } from "antd";
import React from "react";
import { Trans } from "react-i18next";

import AppleButton from "../assets/images/apple-appstore.svg";
import GoogleButton from "../assets/images/google-play.svg";
import Config from "../config";

const styles = {
  constainer: {
    height: "100vh",
    backgroundColor: "#501D3D",
  },
  text: {
    color: "white",
    textAlign: "center" as const,
  },
  buttons: {
    textAlign: "center" as const,
  },
};

interface Props extends RouteComponentProps {}
const Download = (props: Props) => {
  const iOSUrl = Config.dynamicLink.iosUrl;
  const androidUrl = Config.dynamicLink.androidUrl;
  return (
    <Row justify="center" align="middle" style={styles.constainer}>
      <Col>
        <Typography.Title style={styles.text}>Hack Harvest</Typography.Title>
        <Typography.Paragraph style={styles.text}>
          <Trans>Workorder app for Hack Harvest</Trans>
        </Typography.Paragraph>
        <Typography.Paragraph style={styles.text}>
          <Trans>This app can be used with a personal invitation only</Trans>
        </Typography.Paragraph>
        <div style={styles.buttons}>
          <Space>
            <a href={iOSUrl} target="_blank">
              <img src={AppleButton} />
            </a>
            <a href={androidUrl} target="_blank">
              <img src={GoogleButton} />
            </a>
          </Space>
        </div>
      </Col>
    </Row>
  );
};

export default Download;
